import React from "react";
import imageSgarbini from "../../assets/header-logo.png";
function TopNavBarLogo() {
  return (
    <div className="flex items-center py-2 ">
      <img
        src={imageSgarbini}
        alt="Odontoiatria Sgarbini"
        className="w-50 h-16  object-contain"
      />
    </div>
  );
}

export default TopNavBarLogo;
